<template>
    <div class="page">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div
                v-for="item in list"
                :key="item.id"
                class="item"
                @click="goArticleDetail(item.id)"
            >
                <div class="title">{{ item.title }}</div>
                <div class="summary">{{ item.summary }}</div>
                <div class="timeBox">
                    <span class="time">{{ item.pubTime }}</span>
                    <span class="readNum">{{ item.readNum }}人看过</span>
                </div>
            </div>
        </van-list>
        <no-content :msg="'暂无收藏'" v-if="showNoContent"></no-content>
    </div>
</template>

<script>
    import ganhuoService from "../../service/ganhuo.service";
    import noContent from "../../components/no-content/no-content";
    export default {
        name: "ganhuo-detail",
        components: {
            "no-content": noContent,
        },
        data() {
            return {
                loading: true,
                finished: false,
                list: [],
                page: 1,
                row: 10,
                showNoContent: false,
            };
        },
        mounted() {
            if (this.loading) {
                this.onLoad();
            }
        },
        methods: {
            onLoad() {
                ganhuoService
                    .getMyCollects({
                        page: this.page,
                        row: this.row,
                    })
                    .then((res) => {
                        this.list.push(...res.data.list);
                        if (this.list.length >= res.data.total) {
                            this.finished = true;
                        }
                        this.page++;
                        this.loading = false;
                        if (this.list.length <= 0) {
                            this.showNoContent = true;
                            this.loading = false;
                            this.finished = true;
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            goArticleDetail(id) {
                this.$router.push({ path: `/ganhuo-detail/${id}` });
            },
        },
    };
</script>

<style lang="scss" scoped src="./ganhuo-collection.scss"></style>
